module.exports = __webpack_public_path__ + "media/video2.d0f180f1.mp4";